import { ArrowUpDown, ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

const sortOptions = [
  { id: 'popular', label: 'Most Popular', sortBy: 'views', sortOrder: 'desc' },
  { id: 'price-low', label: 'Price: Low to High', sortBy: 'price', sortOrder: 'asc' },
  { id: 'price-high', label: 'Price: High to Low', sortBy: 'price', sortOrder: 'desc' },
  { id: 'duration-short', label: 'Duration: Shortest', sortBy: 'duration_days', sortOrder: 'asc' },
  { id: 'duration-long', label: 'Duration: Longest', sortBy: 'duration_days', sortOrder: 'desc' },
  { id: 'newest', label: 'Newest First', sortBy: 'created_at', sortOrder: 'desc' },
];

export function SortOptions({ value, onChange, className }) {
  const currentSort = sortOptions.find(opt => opt.id === value) || sortOptions[0];

  const handleSortChange = (option) => {
    onChange(option.id, option.sortBy, option.sortOrder);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            'h-12 px-4 rounded-xl border-gray-200 bg-white hover:bg-gray-50',
            'flex items-center gap-2 min-w-[180px] justify-between',
            className
          )}
          data-testid="sort-dropdown"
        >
          <div className="flex items-center gap-2">
            <ArrowUpDown className="w-4 h-4 text-[#4A4A4A]" />
            <span className="text-[#1A1A1A] font-medium">{currentSort.label}</span>
          </div>
          <ChevronDown className="w-4 h-4 text-[#4A4A4A]" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {sortOptions.map((option) => (
          <DropdownMenuItem
            key={option.id}
            onClick={() => handleSortChange(option)}
            className={cn(
              'cursor-pointer py-3',
              value === option.id && 'bg-[#FF6B35]/10 text-[#FF6B35]'
            )}
          >
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
